import { PUBLISHED_STRUCTURED_CONTENT_FIELDS } from '../../fragments/message/published-structured-content-fields';
import { gql } from 'apollo-boost';
import { READ_ONLY_URL_META_FIELDS } from '../../fragments/message/read-only-url-meta-fields';

export const GET_PUBLISHED_MESSAGE = gql`
    query getPublishedMessage($data: GetPublishedMessageInput!) {
        getPublishedMessage(data: $data) {
            id
            title
            body
            createdAt
            artifactBadges { type count }
            entities { type name confidence }
            image {
                public_id
                shared_asset_id
                size
                mime
                duration
                aspect_ratio
                url
                cdn_url
                thumbnail {
                    sm
                    md
                    lg
                    xl
                    original
                }
                name
                displayName
                type
                format
                width
                height
            }
            file {
                public_id
                shared_asset_id
                width
                height
                duration
                aspect_ratio
                thumbnail { sm md lg xl original }
                url
                cdn_url
                name
                displayName
                type
                format
                size
                mime
            }
            ${READ_ONLY_URL_META_FIELDS}
            caption
            keywords
            ocrText
            transcript { text source status sourceUrl urlMetaIndex segments { start end text } }
            transcriptionSegments { start end text }
            ${PUBLISHED_STRUCTURED_CONTENT_FIELDS}
            type {
                type
            }
            sourceHost
            sourceUrls
            canonicalSourceUrls
        }
    }
`;
